import DOMPurify from 'dompurify';

/**
 * Sanitize HTML to prevent XSS attacks.
 * Safe to call during SSR (returns raw string if DOMPurify can't run).
 */
export function sanitizeHtml(html) {
    if (!html) return '';
    if (typeof window === 'undefined') return html;
    return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}

/**
 * Sanitize HTML and convert newlines to <br> tags.
 */
export function sanitizeWithBreaks(html) {
    if (!html) return '';
    const sanitized = sanitizeHtml(html);
    return sanitized.replace(/\n/g, '<br>');
}
